import * as React from "react";
import { useState } from "react";
import TocDropdown from "../../../generic/tocDropdown";
export const FamilySection = (props: any) => {
  var initialObj = {
    mobile_relationship: "",
    email_relationship: "",
    mobile_account_name: "",
    email_account_name: "",
    email_accountCode: "",
    mobile_account_code: "",
  };

  const [familyDeclReqForMob, setFamilyDeclReqForMob] = useState<any>(
    props.emailMobileForm.mobileMatches.length ? [initialObj] : []
  );
  const [familyDeclReqForEmailMob, setFamilyDeclReqForEmailMob] = useState<any>(
    props.emailMobileForm.emailAndMobileMatches.length ? [initialObj] : []
  );
  const [familyDeclReqForEmail, setFamilyDeclReqForEmail] = useState<any>(
    props.emailMobileForm.emailMatches.length ? [initialObj] : []
  );
  React.useEffect(() => {
    if (props.emailMobileForm.mobileMatches.length)
      setFamilyDeclReqForMob([initialObj]);
    else setFamilyDeclReqForMob([]);
  }, [props.emailMobileForm.mobileMatches]);
  React.useEffect(() => {
    if (props.emailMobileForm.emailAndMobileMatches.length)
      setFamilyDeclReqForEmailMob([initialObj]);
    else setFamilyDeclReqForEmailMob([]);
  }, [props.emailMobileForm.emailAndMobileMatches]);
  React.useEffect(() => {
    if (props.emailMobileForm.emailMatches.length)
      setFamilyDeclReqForEmail([initialObj]);
    else setFamilyDeclReqForEmail([]);
  }, [props.emailMobileForm.emailMatches]);

  React.useEffect(() => {
    let allSelected = familyDeclReqForMob
      .concat(familyDeclReqForEmailMob)
      .concat(familyDeclReqForEmail)
      .every((ele: any) => {
        return ele.mobile_relationship || ele.email_relationship;
      });

    if (allSelected) {
      props.onFamilySubmit(
        familyDeclReqForEmail.length > 0 && familyDeclReqForMob.length > 0
          ? [
              {
                mobile_relationship: familyDeclReqForMob[0].mobile_relationship,
                email_relationship: familyDeclReqForEmail[0].email_relationship,
                mobile_account_name: familyDeclReqForMob[0].mobile_account_name,
                email_account_name: familyDeclReqForEmail[0].email_account_name,
                email_accountCode: familyDeclReqForEmail[0].email_accountCode
                  ? familyDeclReqForEmail[0].email_accountCode.trim()
                  : "",
                mobile_account_code: familyDeclReqForMob[0].mobile_account_code
                  ? familyDeclReqForMob[0].mobile_account_code.trim()
                  : "",
              },
            ]
          : familyDeclReqForMob
              .concat(familyDeclReqForEmailMob)
              .concat(familyDeclReqForEmail)
      );
    }
  }, [familyDeclReqForMob, familyDeclReqForEmailMob, familyDeclReqForEmail]);

  const updateFamilyDeclReq = (id: number, data: any, category: any) => {
    let dataup: any = [];

    switch (category) {
      case "emailMob":
        dataup = [...familyDeclReqForEmailMob];
        dataup[id] = data;
        setFamilyDeclReqForEmailMob(dataup);
        break;
      case "mob":
        dataup = [...familyDeclReqForMob];
        dataup[id] = data;
        setFamilyDeclReqForMob(dataup);
        break;
      case "email":
        dataup = [...familyDeclReqForEmail];
        dataup[id] = data;
        setFamilyDeclReqForEmail(dataup);
        break;
    }
  };
  const toCamelCase = (string: any) => {
    return string.replace(/\w\S*/g, function (txt: any) {
      return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
  };
  return (
    <>
      <div className="email-upperspace">
        <p className="field-head">Family Declaration</p>
        <p className="field-subHead desc">
          Your mobile number and/or email ID matches with already existing
          account. Mention your Relation with each account or change your Email
          ID or Mobile Number
        </p>
      </div>
      <div></div>
      <div className="row custom--row">
        {props.emailMobileForm.mobileMatches.length > 0 &&
          props.emailMobileForm.mobileMatches.map((ele: any, index: any) => (
            <>
              <div className="form-field custom-col wd-100">
                <div>
                  <p className="field-head">{toCamelCase(ele.accName)}</p>
                  <p className="field-subHead">Mobile number matches</p>
                </div>
                <div>
                  <TocDropdown
                    selectedValue={
                      familyDeclReqForMob[index]
                        ? familyDeclReqForMob[index].mobile_relationship
                        : ele.familyRelDropdownOptions[0].value
                    }
                    dropdownOptions={
                      familyDeclReqForMob[index] &&
                      familyDeclReqForMob[index].mobile_relationship
                        ? ele.familyRelDropdownOptions.filter(
                            (ele: any, i: any) => {
                              return i !== 0;
                            }
                          )
                        : ele.familyRelDropdownOptions
                        ? ele.familyRelDropdownOptions
                        : []
                    }
                    onSelect={(val) => {
                      if (val !== "")
                        updateFamilyDeclReq(
                          index,
                          {
                            mobile_relationship: val,
                            email_relationship: "",
                            mobile_account_name: ele.accName,
                            email_account_name: "",
                            email_accountCode: "",
                            mobile_account_code: ele.accCode
                              ? ele.accCode.trim()
                              : "",
                          },
                          "mob"
                        );
                    }}
                    isSearchable={false}
                  />
                </div>
              </div>
            </>
          ))}

        {props.emailMobileForm.emailMatches.length > 0 &&
          props.emailMobileForm.emailMatches.map((ele: any, index: any) => (
            <>
              <div className="form-field custom-col wd-100">
                <div>
                  <p className="field-head">{toCamelCase(ele.accName)}</p>
                  <p className="field-subHead">Email matches</p>
                </div>
                <div>
                  <TocDropdown
                    selectedValue={
                      familyDeclReqForEmail[index]
                        ? familyDeclReqForEmail[index].email_relationship
                        : ele.familyRelDropdownOptions[0].value
                    }
                    dropdownOptions={
                      familyDeclReqForEmail[index] &&
                      familyDeclReqForEmail[index].email_relationship
                        ? ele.familyRelDropdownOptions.filter(
                            (ele: any, i: any) => {
                              return i !== 0;
                            }
                          )
                        : ele.familyRelDropdownOptions
                        ? ele.familyRelDropdownOptions
                        : []
                    }
                    onSelect={(val) => {
                      if (val !== "")
                        updateFamilyDeclReq(
                          index,
                          {
                            mobile_relationship: "",
                            email_relationship: val,
                            mobile_account_name: "",
                            email_account_name: ele.accName,
                            email_accountCode: ele.accCode
                              ? ele.accCode.trim()
                              : "",
                            mobile_account_code: "",
                          },
                          "email"
                        );
                    }}
                    isSearchable={false}
                  />
                </div>
              </div>
            </>
          ))}
        <div className="form-field custom-col wd-100">
          {props.emailMobileForm.emailAndMobileMatches.length > 0 &&
            props.emailMobileForm.emailAndMobileMatches.map(
              (ele: any, index: any) => (
                <>
                  <div>
                    <p className="field-head">{toCamelCase(ele.accName)}</p>
                    <p className="field-subHead">
                      Email and Mobile number matches
                    </p>
                  </div>
                  <div>
                    <TocDropdown
                      selectedValue={
                        familyDeclReqForEmailMob[index]
                          ? familyDeclReqForEmailMob[index].mobile_relationship
                          : ele.familyRelDropdownOptions[0].value
                      }
                      dropdownOptions={
                        familyDeclReqForEmailMob[index] &&
                        familyDeclReqForEmailMob[index].mobile_relationship
                          ? ele.familyRelDropdownOptions.filter(
                              (ele: any, i: any) => {
                                return i !== 0;
                              }
                            )
                          : ele.familyRelDropdownOptions
                          ? ele.familyRelDropdownOptions
                          : []
                      }
                      onSelect={(val: any) => {
                        if (val !== "")
                          updateFamilyDeclReq(
                            index,
                            {
                              mobile_relationship: val,
                              email_relationship: val,
                              mobile_account_name: ele.accName,
                              email_account_name: ele.accName,
                              email_accountCode: ele.accCode
                                ? ele.accCode.trim()
                                : "",
                              mobile_account_code: ele.accCode
                                ? ele.accCode.trim()
                                : "",
                            },
                            "emailMob"
                          );
                      }}
                      isSearchable={false}
                    />
                  </div>
                </>
              )
            )}
        </div>
      </div>
    </>
  );
};
